
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-government-line text-xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold">芦江土地家屋調査士事務所</h3>
                <p className="text-gray-400 text-sm">代表：芦江諒介</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              大分県全域・近隣地域を対象とした土地家屋調査士事務所です。土地境界確定から建物登記まで、
              正確な測量技術と豊富な専門知識で、お客様の大切な不動産に関する手続きを丁寧にサポートいたします。
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center text-gray-300">
                <i className="ri-map-pin-line mr-2"></i>
                <span className="text-sm">大分県・近隣地域対応</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">クイックリンク</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-blue-400 transition-colors text-sm cursor-pointer"
                >
                  ホーム
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-blue-400 transition-colors text-sm cursor-pointer"
                >
                  サービス
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-blue-400 transition-colors text-sm cursor-pointer"
                >
                  事務所について
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('process')}
                  className="text-gray-300 hover:text-blue-400 transition-colors text-sm cursor-pointer"
                >
                  業務の流れ
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-blue-400 transition-colors text-sm cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">主なサービス</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>土地境界確定測量</li>
              <li>建物表題登記</li>
              <li>土地分筆・合筆登記</li>
              <li>地積更正登記</li>
              <li>建物滅失登記</li>
              <li>不動産登記相談</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 芦江土地家屋調査士事務所. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 text-sm transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
